import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { API_V1_BASE } from '@config';
import { WithParams } from '@utils/typescript';

export type CreateAuthMemberIdParams = WithParams<{
  member_id: string;
  dob: string;
}>

export class AuthMemberIdApi {
  static create = async (params: CreateAuthMemberIdParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/auth/member_id`, snakes(params))
      .then((response) => humps(response.data) as { accessToken: string });
  };
}
